module.exports = __webpack_public_path__ + "static/media/img2-2.05f64efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/biosense/diff/img2-2.png
// module id = 1031
// module chunks = 3